import * as types from 'constants/alertActionTypes';
import { ALERT_INFO_TYPE } from 'constants/alertTypes';

const initialState = {
  visible: false,
  message: '',
  type: ALERT_INFO_TYPE,
  autoclose: true
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.SHOW_ALERT: {
      const { options } = action;
      return {
        ...state,
        visible: true,
        message: action.message,
        type: action.variant,
        autoclose: options?.autoclose !== false
      };
    }
    case types.HIDE_ALERT:
      return { visible: false, message: '', autoclose: true };
    default:
      return state;
  }
};
